<template>
  <iframe class="flex-1" src="https://tracker2.bitrix24.site/pomoshch/"></iframe>
    <!-- <div class="flex-1">
        <h4 class="mt-5">Первоначальная настройка приложения:</h4>
        <p>1. В разделе меню "Настойки-Приложение" выберите поле сделки "UF_CRM_TRK_TRACKER",из которого будет считываться трек-номер. Вы можете выбрать другое поле или создать свое</p>
        <p>2. В разделе меню "Настройки-Интеграции" выберите интегрируемую службу доставки и введите ключи интеграции (служба доставки выдает по запросу или обратитесь в нашу службу поддержки)</p>
        <br>
        <h4>Настройка сделки:</h4>
        <p>1. Зайдите в любую сделку</p>
        <p>2. В самом низу сделки, нажмите кнопку "Создать раздел", дайте название разделу, например "Доставка"</p>
        <p>3. Нажмите кнопку "Выбрать поле" -> "Выбрать из другого раздела"</p>
        <p>4. В открывшемся списке полей выберите "Трек-номер (Трекер)", "Транспортная компания (Трекер)", "Статус краткий (Трекер)", "Статус расширенный (Трекер)", "История (Трекер)"</p>
        <br>
        <h4>Использование:</h4>
        <p>После настроек, в любой сделке добавьте трек-номер, выберите службу доставки из списка и сохраните сделку. Сервис отслеживани посылок во время обновления просканирует трек-номер сделки и добавит информацию по отправлению в сделку. Обновление статусов запускается каждый день в 3 часа ночи по Москве.</p>
        <br>
        <p>Техническая поддержка: <a class="ml-1" target="_blank" href="mailto:info@rocket-lab.ru">info@rocket-lab.ru</a></p>
        
    </div> -->
</template>

<script>
import axios from 'axios'

export default {
  name: 'FAQ',
  data: function() {
    return {
     
    }
  },
  created: function() {
    
  },
}
</script>
<style scope>
.faqq{
    height: auto !important;
}

iframe{
  width: 100%;
  border: none;
}
</style>
